window.GIFTBOX_CUSTOM_CART_ITEMS_SELECTORS = ["m-cart-drawer--items > .m-cart-drawer--item", ".m-cart-items > .m-cart--item"]
window.GIFTBOX_CUSTOM_CART_REMOVE_LINK_SELECTORS= ["a.m-cart--item-name"]
window.GIFTBOX_CUSTOM_CART_REMOVE_INPUTS_SELECTORS = ["m-quantity-input", ".m-cart-quantity--button[name='minus']"]

window.GIFTBOX_CUSTOM_UPDATE_CART = () => {
document.querySelector('#cart-drawer-form .m-cart-quantity--input').dispatchEvent(new Event("change", { bubbles: true }));
}


setInterval(()=>{
    const items = document.querySelectorAll(".m-cart-drawer--item")
  items.forEach(i=>{
        const title = i.querySelector("a.m-cart--item-name[href*='free-gift']")
        if (title) {
            const q = i.querySelector("m-quantity-input")
          
            q.style.opacity = "0.25"
            q.style.pointerEvents = "none"
        }
    }
    )

}
, 100)